import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fg } from '@atlaskit/platform-feature-flags';
import { createRootCriticalMetricsPayload } from './root-metrics';
import { createSegmentMetricsPayloads } from './segment-metrics/create-segment-metrics';
export function createCriticalMetricsPayloads(_x, _x2, _x3) {
  return _createCriticalMetricsPayloads.apply(this, arguments);
}
function _createCriticalMetricsPayloads() {
  _createCriticalMetricsPayloads = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(interactionId, interaction, vcMetrics) {
    var _yield$Promise$all, _yield$Promise$all2, rootPayload, segmentPayloads;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.all([createRootCriticalMetricsPayload(interactionId, interaction, vcMetrics), fg('platform_ufo_segment_critical_metrics') ? createSegmentMetricsPayloads(interactionId, interaction) : []]);
        case 2:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          rootPayload = _yield$Promise$all2[0];
          segmentPayloads = _yield$Promise$all2[1];
          return _context.abrupt("return", [rootPayload].concat(_toConsumableArray(segmentPayloads)).filter(function (v) {
            return v != null;
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createCriticalMetricsPayloads.apply(this, arguments);
}